import React, { useEffect, useState } from 'react'
import { HeaderMenu } from '../../components/HeaderMenu.comp'
import { Box, Button, Drawer, Tab, Tabs, TextField } from '@mui/material'
import PropTypes from 'prop-types';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import CategoryIcon from '@mui/icons-material/Category';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { CrudAdminProducto } from '../../API/AdminTemp/CrudAdminProducto.api';
import { CrudAdminTemp } from '../../API/AdminTemp/CrudAdminTemp.api';
import SearchIcon from '@mui/icons-material/Search';
import { set } from 'date-fns';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function CustomTabPanel_2(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-2-${index}`}
      aria-labelledby={`simple-tab-2-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function CustomTabPanel_3(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-3-${index}`}
      aria-labelledby={`simple-tab-3-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
CustomTabPanel_2.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
CustomTabPanel_3.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
function a11yProps_2(index) {
  return {
    id: `simple-tab-2-${index}`,
    'aria-controls': `simple-tabpanel-2-${index}`,
  };
}
function a11yProps_3(index) {
  return {
    id: `simple-tab-3-${index}`,
    'aria-controls': `simple-tabpanel-3-${index}`,
  };
}

export const CtrlTempAdmin = () => {
    const [BaulProductos, setBaulProductos] = React.useState([]);
    const [BaulProductos_bkp, setBaulProductos_bkp] = React.useState(BaulProductos);
    const [BaulTemp, setBaulTemp] = React.useState([]);
    const [BaulTemp_bkp, setBaulTemp_bkp] = React.useState([]);
    
    const [value, setValue] = React.useState(0);
    const [value_2, setValue_2] = React.useState(0);
    const [value_3, setValue_3] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChange_2 = (event, newValue) => {
        setValue_2(newValue);
    };
    const handleChange_3 = (event, newValue) => {
        setValue_3(newValue);
    };

    //DATOS DE PRODUCTOS
    const [Codigo_P, setCodigo_P] = React.useState();
    const [Producto_P, setProducto_P] = React.useState();
    const [Producto_P_selected, setProducto_P_selected] = React.useState();
    const [Grupo_P, setGrupo_P] = React.useState();
    const [Mercado_P, setMercado_P] = React.useState();

    //drawer productos
    const [state_P, setState_P] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const toggleDrawer_P = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        if(anchor === "bottom" && open){
            setProducto_P_selected()
        }
        setState_P({ ...state_P, [anchor]: open });
        setProducto_P_selected()
    };

    const  crudDeProductos = async (type,data) => {
        // console.log(type,data);
        
        const createProducto = async (data) => {
            // console.log("CREATE PRODUCTO",data);
            const  isSure = confirm("¿Seguro que desea agregar este producto?")
            if(isSure){
                // console.log("Agregar producto",data);
                await CrudAdminProducto({type:"CREATE",data})
                alert("Producto agregado correctamente")
                setCodigo_P('')
                setProducto_P('')
                setGrupo_P('')
                setMercado_P('')
                let rsp = await CrudAdminProducto({type:"READ"})
                setBaulProductos(rsp);
                setBaulProductos_bkp(rsp);
            }
        }

        const readProducto = async () => {
            // console.log("READ PRODUCTO");
            let rsp = await CrudAdminProducto({type:"READ"})
            setBaulProductos(rsp);
            setBaulProductos_bkp(rsp);
        }

        const updateProducto = async (data) => {
            // console.log("UPDATE",data);
            const isUpdated = confirm("¿Seguro que desea editar este producto?")
            if(isUpdated){
                await CrudAdminProducto({type:"UPDATE",data})
                let rsp = await CrudAdminProducto({type:"READ"})
                setBaulProductos(rsp);
                setBaulProductos_bkp(rsp);
                setState_P({"bottom": false})
                setProducto_P_selected()
            }
        }

        const deleteProducto = async (data) => {
            const isDeleted = await confirm("¿Seguro que desea eliminar este producto?")
            if(isDeleted){
                // console.log("DELETE",data);
                await CrudAdminProducto({type:"DELETE",data})
                let rsp = await CrudAdminProducto({type:"READ"})
                setBaulProductos(rsp);
                setBaulProductos_bkp(rsp);
            }
        }

        switch (type) {
            case "CREATE":
                // console.log("CREATE",data);
                await createProducto(data)
                return

            case "READ":
                // console.log("READ");
                await readProducto()
                return

            case "UPDATE":
                // console.log("UPDATE",data);
                await updateProducto(data)
                return

            case "DELETE":
                // console.log("DELETE",data);
                await deleteProducto(data)
                return
        }
    }

    //DATOS DE TEMPERATURAS

    const [FechaInicio, setFechaInicio] = useState()
    const [FechaFinal, setFechaFinal] = useState()
    const [Temperatura_P_selected, setTemperatura_P_selected] = React.useState();

    //drawer productos
    const [state_T, setState_T] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const toggleDrawer_T = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        if(anchor === "bottom" && open){
            setProducto_P_selected()
        }
        setProducto_P_selected()
        setState_T({ ...state_T, [anchor]: open });
    };


    const  crudDeTemperatura = async (type,data) => {
        // console.log(type,data);
        
        const createTemperatura = async (data) => {
        }

        const readTemperatura = async () => {
            // console.log("READ TEMPERATURA");
            let arrTemps = await CrudAdminTemp({type:"READ",data:{inicio:new Date(FechaInicio+"T00:00:00.000Z").getTime(),fin:new Date(FechaFinal+"T23:59:59.999Z").getTime()}})
            // console.log(arrTemps);
            setBaulTemp(arrTemps);
            setBaulTemp_bkp(arrTemps);
        }

        const updateTemperatura = async (data) => {
            // console.log("UPDATE TEMPERATURA", data);
            let arrTemps = await CrudAdminTemp({type:"UPDATE",data})
            crudDeTemperatura("READ")
            setState_T({"bottom": false})
            setProducto_P_selected()

        }

        const deleteTemperatura = async (data) => {
        }

        switch (type) {
            case "CREATE":
                // console.log("CREATE",data);
                await createTemperatura(data)
                return

            case "READ":
                // console.log("READ");
                await readTemperatura()
                return

            case "UPDATE":
                // console.log("UPDATE",data);
                await updateTemperatura(data)
                return

            case "DELETE":
                // console.log("DELETE",data);
                await deleteTemperatura(data)
                return
        }
    }

    useEffect(() => {
        crudDeProductos("READ")
        crudDeTemperatura("READ")
        return () => {
            crudDeProductos("READ")
            crudDeTemperatura("READ")
        }
    }, [])
    

    
    return (<>
        <HeaderMenu Pag_Sel={'ctrl_tempadmin'}/>
        
        {/* botones principales */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
                <Tab icon={<CategoryIcon/>} label="Productos" {...a11yProps(0)} />
                <Tab icon={<DeviceThermostatIcon/>} label="Temperaturas" {...a11yProps(1)} />
                {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
            </Tabs>
        </Box>
        {/* pestaña de producto */}
        <CustomTabPanel value={value} index={0}>

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value_2} onChange={handleChange_2} aria-label="basic tabs example" centered>
                    <Tab label="editar o eliminar producto" {...a11yProps_2(0)} />
                    <Tab label="agregar producto" {...a11yProps_2(1)} />
                    {/* <Tab label="Item Three" {...a11yProps(2)} /> */}
                </Tabs>
            </Box>

            {/* crear producto */}
            <CustomTabPanel_2 value={value_2} index={1}>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12 col-md-2 mt-2'>
                            <TextField
                                fullWidth
                                size='small'
                                id="outlined-basic"
                                label="CODIGO"
                                variant="outlined"
                                value={Codigo_P}
                                onChange={(e)=>setCodigo_P(e.target.value.toUpperCase())}
                            />
                        </div>
                        <div className='col-12 col-md-4 mt-2'>
                            <TextField
                                fullWidth
                                size='small'
                                id="outlined-basic"
                                label="NOMBRE PRODUCTO"
                                variant="outlined"
                                value={Producto_P}
                                onChange={(e)=>setProducto_P(e.target.value.toUpperCase())}
                            />
                        </div>
                        <div className='col-12 col-md-2 mt-2'>
                            <TextField
                                fullWidth
                                size='small'
                                id="outlined-basic"
                                label="GRUPO CARNICO"
                                variant="outlined"
                                value={Grupo_P}
                                onChange={(e)=>setGrupo_P(e.target.value.toUpperCase())}
                            />
                        </div>
                        <div className='col-12 col-md-2 mt-2'>
                            <TextField
                                fullWidth
                                size='small'
                                id="outlined-basic"
                                label="MERCADO"
                                variant="outlined"
                                value={Mercado_P}
                                onChange={(e)=>setMercado_P(e.target.value.toUpperCase())}
                            />
                        </div>
                        <div className='col-12 col-md-2 mt-2'>
                            <Button
                                variant="contained"
                                disabled={!Codigo_P || !Producto_P || !Grupo_P || !Mercado_P}
                                onClick={()=>crudDeProductos("CREATE",{COD_PRODUCTO:Codigo_P, PRODUCTO:Producto_P, MEAT:Grupo_P, MERCADO:Mercado_P})}>agregar</Button>
                        </div>
                    </div>
                </div>
            </CustomTabPanel_2>
            {/* lista de productos en tabla para editar o eliminar */}
            <CustomTabPanel_2 value={value_2} index={0}>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12 col-md-4 mt-2'>
                            <TextField
                                fullWidth
                                size='small'
                                id="outlined-basic"
                                label="BUSCAR PRODUCTO"
                                variant="outlined"
                                onChange={(e)=>{
                                    const search = e.target.value.toUpperCase();
                                    if(search.length > 0){
                                        const filter = BaulProductos.filter(itm => itm.PRODUCTO.toUpperCase().includes(search) || itm.COD_PRODUCTO.toUpperCase().includes(search))  
                                        setBaulProductos_bkp(filter);
                                    }else{
                                        setBaulProductos_bkp(BaulProductos);
                                    }
                                }}
                            />
                        </div>
                        <div className='col-12 mt-2'>
                            <table className="table">
                                <thead className="thead-dark">
                                    <tr>
                                        <th scope="col">CODIGO</th>
                                        <th scope="col">NOMBRE PRODUCTO</th>
                                        <th scope="col">GRUPO CARNICO</th>
                                        <th scope="col">MERCADO</th>
                                        <th scope="col">ACCION</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    BaulProductos_bkp&&BaulProductos_bkp.map((itm,idx)=>
                                        <tr key={itm._id}>
                                            <th scope="row">{itm.COD_PRODUCTO}</th>
                                            <td>{itm.PRODUCTO}</td>
                                            <td>{itm.MEAT}</td>
                                            <td>{itm.MERCADO}</td>
                                            <td>
                                                <EditIcon
                                                    color='primary'
                                                    onClick={()=>{
                                                        setState_P({"bottom": true})
                                                        setProducto_P_selected(itm)}
                                                        }/>
                                                <DeleteForeverIcon color='error' onClick={()=>crudDeProductos("DELETE",itm)}/>
                                            </td>
                                        </tr>
                                    )
                                }
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </CustomTabPanel_2>

        </CustomTabPanel>

        {/* pestaña de temperatura */}
        <CustomTabPanel value={value} index={1}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value_3} onChange={handleChange_3} aria-label="basic tabs example" centered>
                    <Tab label="editar temperatura" {...a11yProps_3(0)} />
                </Tabs>
            </Box>
            {/* editar temperatura */}
            <CustomTabPanel_3 value={value_3} index={0}>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12 col-md-4'>
                            <span className='fotmar-inp-date-label'>Fecha Inicio</span>
                            <input
                                type='date'
                                className='fotmar-inp-date'
                                max={new Date().toISOString().split('T')[0]}
                                value={FechaInicio}
                                onChange={(e)=>setFechaInicio(e.target.value)}
                            />
                        </div>
                        <div className='col-12 col-md-4'>
                            <span className='fotmar-inp-date-label'>Fecha Final</span>
                            <input
                                type='date'
                                className='fotmar-inp-date'
                                max={new Date().toISOString().split('T')[0]}
                                value={FechaFinal}
                                onChange={(e)=>setFechaFinal(e.target.value)}
                            />
                        </div>
                        <div className='col-12 col-md-4 mt-4'>
                            <button className='btn btn-sm btn-outline-info' onClick={()=>crudDeTemperatura("READ")}>
                                <SearchIcon />
                            </button>
                        </div>
                        <div className='col-12 mt-2'>
                            <table className="table">
                                <thead className="thead-dark">
                                    <tr>
                                        {/* <th scope="col">ID</th> */}
                                        <th scope="col">CODIGO</th>
                                        <th scope="col">PRODUCTO</th>
                                        <th scope="col">MAQUINA</th>
                                        <th scope="col">N°OF</th>
                                        <th scope="col">FECHA</th>
                                        <th scope="col">ACCION</th>
                                    </tr>
                                </thead>
                                <tbody>

                                {
                                    BaulTemp_bkp&&BaulTemp_bkp.map((itm,idx)=>
                                        <tr key={itm._id}>
                                            {/* <td>{itm._id}</td> */}
                                            <th scope="row">{itm.CODPRODUCTO}</th>
                                            <td>{itm.PRODUCTO}</td>
                                            <td>{itm.MAQUINA}</td>
                                            <td>{itm.N_OF}</td>
                                            <td>{new Date(itm.FECHA).toLocaleString()}</td>
                                            <td className='text-center'>
                                                <EditIcon
                                                    color='primary'
                                                    onClick={()=>{
                                                        setState_T({"bottom": true})
                                                        setTemperatura_P_selected(itm)
                                                    }}
                                                />
                                                {/* <DeleteForeverIcon color='error' onClick={()=>crudDeTemperatura("DELETE",itm)}/> */}
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </CustomTabPanel_3>
        </CustomTabPanel>

        {/* drawer edit productos */}
        <Drawer
            anchor={"bottom"}
            open={state_P["bottom"]}
            onClose={toggleDrawer_P("bottom", false)}
          >
            <div className='container-fluid mb-5'>
                <div className='row'>
                    <div className='col-12 text-white mb-5 py-3 mb-2 bg-dark'>
                        <span className='lead'>EDITAR PRODUCTO</span>
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="CODIGO"
                            variant="outlined"
                            value={Producto_P_selected?.COD_PRODUCTO}
                            onChange={(e)=>setProducto_P_selected({...Producto_P_selected, COD_PRODUCTO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-4 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="NOMBRE PRODUCTO"
                            variant="outlined"
                            value={Producto_P_selected?.PRODUCTO}
                            onChange={(e)=>setProducto_P_selected({...Producto_P_selected, PRODUCTO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="GRUPO CARNICO"
                            variant="outlined"
                            value={Producto_P_selected?.MEAT}
                            onChange={(e)=>setProducto_P_selected({...Producto_P_selected, MEAT:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="MERCADO"
                            variant="outlined"
                            value={Producto_P_selected?.MERCADO}
                            onChange={(e)=>setProducto_P_selected({...Producto_P_selected, MERCADO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <Button
                            variant="contained"
                            onClick={()=>crudDeProductos("UPDATE",Producto_P_selected)}>EDITAR</Button>
                    </div>
                </div>
            </div>
        </Drawer>

        {/* drawer edit temperaturas */}
        <Drawer
            anchor={"bottom"}
            open={state_T["bottom"]}
            onClose={toggleDrawer_T("bottom", false)}
          >
            <div className='container-fluid mb-5'>
                <div className='row'>
                    <div className='col-12 text-white mb-5 py-3 mb-2 bg-dark'>
                        <span className='lead'>EDITAR TEMPERATURA</span>
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            focused
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="CODIGO"
                            variant="outlined"
                            value={Temperatura_P_selected?.CODPRODUCTO}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, CODPRODUCTO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-4 mt-2'>
                        <TextField
                            fullWidth
                            focused
                            size='small'
                            id="outlined-basic"
                            label="PRODUCTO"
                            variant="outlined"
                            value={Temperatura_P_selected?.PRODUCTO}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, PRODUCTO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="MAQUINA"
                            variant="outlined"
                            focused
                            value={Temperatura_P_selected?.MAQUINA}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, MAQUINA:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="FECHA"
                            variant="outlined"
                            disabled
                            value={new Date(Temperatura_P_selected?.FECHA).toLocaleString()}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, FECHA:e.target.value.toUpperCase()})}
                        />
                    </div>
                     <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="NUMERO DE OF"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.N_OF}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, N_OF:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="TEMP AIRE"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.T_AIRE}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, T_AIRE:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="TEMP SUCCION"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.T_SUCCION}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, T_SUCCION:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="RESIDENCIA"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.RESIDENCIA}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, RESIDENCIA:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="TEMP MARINADO"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.T_MARINADO}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, T_MARINADO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="KG HORA"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.KG_HORA}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, KG_HORA:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="TEMP GLASEADO"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.T_GLASEADO}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, T_GLASEADO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="TEMP PRODUCTO"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.T_PRODUCTO}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, T_PRODUCTO:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="TEMP CAMARA"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.T_CAMARA}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, T_CAMARA:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="TEMP ENTRADA"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.T_ENTRADA}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, T_ENTRADA:e.target.value.toUpperCase()})}
                        />
                    </div>
                    <div className='col-12 col-md-2 mt-2'>
                        <TextField
                            fullWidth
                            size='small'
                            id="outlined-basic"
                            label="TEMP SALIDA"
                            variant="outlined"
                            type='number'
                            focused
                            value={Temperatura_P_selected?.T_SALIDA}
                            onChange={(e)=>setTemperatura_P_selected({...Temperatura_P_selected, T_SALIDA:e.target.value.toUpperCase()})}
                        />
                    </div>

                    <div className='col-12 mt-2 text-right'>
                        <Button
                            variant="contained"
                            onClick={()=>crudDeTemperatura("UPDATE",Temperatura_P_selected)}>EDITAR</Button>
                    </div>
                </div>
            </div>
        </Drawer>
        </>
    )
}
